/**
 * @format
 */
import reducers from './reducers';
import * as types from './actions';
import request from '../../helpers/request';
import { enqueueNotification } from '../app';

export default reducers;

export const addTask = pitchData => {
  return async dispatch => {
    dispatch({ type: types.CREATE_TASK_LOADING });

    try {
      const { data } = await request.post(`/api/tasks/v1`, pitchData, dispatch);

      if (data.success) {
        dispatch({
          type: types.CREATE_TASK_SUCCESS,
          payload: {
            taskId: data.data.id,
            task: data.data,
          },
        });
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: types.CREATE_TASK_FAILURE,
          payload: message,
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while creating task, please try again.';
      dispatch({
        type: types.CREATE_TASK_FAILURE,
        payload: message,
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};

export const loadAllTask = (params = {}) => {
  return async dispatch => {
    dispatch({ type: types.GET_ALL_TASKS_LOADING });

    try {
      const { data } = await request.get(`/api/tasks/v1`, params, dispatch);
      if (data.success) {
        dispatch({
          type: types.GET_ALL_TASKS_SUCCESS,
          payload: {
            tasks: data.data,
          },
        });
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: types.GET_ALL_TASKS_FAILURE,
          payload: message,
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while loading tasks, please try again.';
      dispatch({
        type: types.GET_ALL_TASKS_FAILURE,
        payload: message,
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};

export const loadTaskById = (taskId, params = {}) => {
  return async dispatch => {
    dispatch({ type: types.GET_TASK_LOADING });

    try {
      const { data } = await request.get(
        `/api/tasks/v1/${taskId}`,
        params,
        dispatch
      );

      if (data.success) {
        dispatch({
          type: types.GET_TASK_SUCCESS,
          payload: {
            task: data.data,
          },
        });
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: types.GET_ALL_TASKS_FAILURE,
          payload: message,
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while loading task, please try again.';
      dispatch({
        type: types.GET_TASK_FAILURE,
        payload: message,
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};

export const updateTasks = pitchData => {
  return async dispatch => {
    dispatch({ type: types.UPDATE_TASK_LOADING });
    try {
      const { data } = await request.put('/api/tasks/v1', pitchData, dispatch);
      if (data.success) {
        dispatch({
          type: types.UPDATE_TASK_SUCCESS,
          payload: {
            tasks: data.data,
          },
        });
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: types.UPDATE_TASK_FAILURE,
          payload: message,
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while updating tasks, please try again.';
      dispatch({
        type: types.UPDATE_TASK_FAILURE,
        payload: message,
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};
